import { UserMedicalExaminationFilters } from '@/interfaces/filters/userMedicalExaminationFilters';
import { ListResponse } from '@/interfaces/list';
import { MedicalExamination } from '@/interfaces/medicalExamination';
import { MedicalExaminationResource, medicalExaminationResource } from '@/resources/medicalExamination.resource';
import { EntityModule } from '../entity.module';

/**
 * Moduł badań lekarskich użytkownika
 *
 * @export
 * @class UserMedicalExaminationModule
 * @extends {EntityModule<MedicalExamination, MedicalExaminationResource>}
 */
export class UserMedicalExaminationModule extends EntityModule<MedicalExamination, MedicalExaminationResource> {
  constructor() {
    super(medicalExaminationResource);

    this.actions = {
      ...this.actions,

      /**
       * Lista badań lekarskich użytkownika
       *
       * @param {*} context
       * @param {UserMedicalExaminationFilters} filters
       * @returns {Promise<void>}
       */
      list: (context: any, filters: UserMedicalExaminationFilters): Promise<void> => {
        filters.profileId = context.rootState.profile.id;
        return this.resource
          .userMedicalExaminationList(filters)
          .then(({ list, count }: ListResponse<MedicalExamination>) => {
            context.commit('saveList', list);
            context.commit('saveCount', count);
          });
      }
    };
  }
}

export default new UserMedicalExaminationModule();
